import { Injectable, computed, inject } from '@angular/core';
import { AuthService } from '@authentication/services/auth.service';
import { LocalStorageService } from '@core/storage/local-storage.service';
import { injectModal } from '@fnccr-actee/design-system';
import { filter, firstValueFrom } from 'rxjs';
import { OnboardingPopupComponent } from './onboarding-popup.component';
import { OnboardingActions } from './onboarding.types';

@Injectable({
  providedIn: 'root',
})
export class OnboardingController {
  private readonly _modal = injectModal();
  private readonly _authService = inject(AuthService);
  private readonly _localStorageService = inject(LocalStorageService);

  readonly firstName = computed(() => this._authService.currentUser()?.firstName ?? '');
  readonly communityName = computed(
    () =>
      this._authService.currentUser()?.communities?.find((community) => community.isMain)?.name ??
      this._authService.currentUser()?.communities?.[0]?.name ??
      '',
  );

  async handleOnboardingTutorialModalOpening(): Promise<void> {
    const user = await firstValueFrom(this._authService.currentUser$.pipe(filter(Boolean)));
    if (this._localStorageService.isOnboardingDone(user.id)) return;

    const result = await this._modal.open<OnboardingActions>({
      component: OnboardingPopupComponent,
      size: 'large',
      hideCloseButton: true,
    });

    if (result?.hideForever) {
      this._localStorageService.storeOnboardingDone(user.id);
    }
  }
}
